import React from 'react'

import { StyledRadioControlBox, StyledDividerLine } from './RadioControlBox.styles'

import Form from "@emcm-ui/component-form";

/**
 * RadioControlBox
 * 
 * A custom layout for EMCM's <Form.RadioControl>.
 *
 * It's a group of radio buttons inside a box with round borders and divider lines.
 * Only used in the export dialog.
 * 
 * Reason this exists is that <Form.RadioControl> doesn't allow individual
 * positioning of the radio buttons.
 * 
 * It's an interim solution - in the future radio buttons will be separated
 * from Form.RadioControl and moved to individual components.
 * 
 */
const RadioControlBox = ({ name, options } ) => {
 
  return(
    <StyledRadioControlBox>

      {/* 
        The EMCM radio buttons 
      */}
      <Form.RadioControl
        name={name}
        options={options}
        defaultValue={options[0].value}
      />

      {/* 
        If there's more than 1 option: Adds and distributes divider lines vertically 
      */}
      {(options.length > 1) && options.slice(0, options.length - 1).map( (option, i) => {
          const y = ( (i + 1) / options.length ) * 100

          return <StyledDividerLine top={`${y}%`} key={`d${i}`} />
        })}

    </StyledRadioControlBox>
  )

}

export default RadioControlBox;
